import { render, staticRenderFns } from "./LocumOffersBasedOnLocation.vue?vue&type=template&id=5a898728&"
import script from "./LocumOffersBasedOnLocation.vue?vue&type=script&lang=js&"
export * from "./LocumOffersBasedOnLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports